import React from 'react';
import './TaskModal.css';

export default function TaskModal({ open, onClose, tasks }) {
  if (!open) return null;

  const single = tasks && tasks.length === 1;

  return (
    <div className="tm-overlay" onClick={onClose}>
      <div className="tm-modal" onClick={e => e.stopPropagation()}>
        <button className="tm-close" onClick={onClose}>✕</button>
        <h3>{single ? 'Détails tâche' : `Tâches (${tasks.length})`}</h3>

        <div className="tm-list">
          {tasks && tasks.map(task => (
            <div key={task.id} className="tm-item card">
              <div className="tm-title">{task.title}</div>
              <div className="tm-meta">
                <span>Phase: {task.phase_name || task.phase_id || '—'}</span>
                <span>Status: {task.status}</span>
                <span>Priorité: {task.priority}</span>
                <span>Progress: {task.progress || 0}%</span>
              </div>
              {task.description && <p className="tm-desc">{task.description}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
